import { useSelector } from 'react-redux';
import { tokenPayloadSelector } from 'state/auth/auth.selectors';
import { UserRole } from 'models/token';
import { useMemo } from 'react';

export function useRole() {
  const tokenPayload = useSelector(tokenPayloadSelector);

  return useMemo(() => {
    return {
      isSuperAdmin: UserRole.SuperAdmin === tokenPayload?.role,
      isAdmin: UserRole.Admin === tokenPayload?.role,
      isMedicalOperator: UserRole.MedicalOperator === tokenPayload?.role,
      isDemo: UserRole.DemoAccount === tokenPayload?.role,
      isAdministrationRole:
        tokenPayload &&
        [UserRole.Admin, UserRole.SuperAdmin, UserRole.DemoAccount].includes(
          tokenPayload.role
        ),
      role: tokenPayload?.role,
    };
  }, [tokenPayload]);
}
